const SITE_CONFIG = {
  SITE_NAME: 'Naumai',
  SITE_HOMEPAGE_CONTENT_SERVICE_SLUG: 'naumai-homepage',
  SITE_ROOT_PATH: '/',
  SITE_PROD_BASE_URL: 'https://www.naumai.studywithnewzealand.govt.nz',
}

export default SITE_CONFIG
